// StockIssuePage.jsx
import React, { useState } from 'react';
import StockIssueForm from '../components/StockIssueForm';

const StockIssuePage = () => {
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState(null);

  const handleSubmit = async (payload) => {
    setLoading(true);
    setNotification(null);
    
    try {
      let endpoint = '/api/stock/issues';
      
      if (payload.employee_id) {
        endpoint = '/api/stock/issues/employee';
      } else if (payload.authorized_by) {
        endpoint = '/api/stock/issues/controlled';
      } else if (payload.patient_id) {
        endpoint = '/api/stock/issues/patient';
      }

      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error('Failed to issue stock');
      }

      const data = await response.json();
      
      setNotification({
        type: 'success',
        message: 'Stock issued successfully!'
      });

      // Auto-hide notification after 5 seconds
      setTimeout(() => {
        setNotification(null);
      }, 5000);
      
    } catch (error) {
      setNotification({
        type: 'error',
        message: error.message || 'Failed to issue stock'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-6xl mx-auto px-4">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">
          Stock Issue Management
        </h1>
        <p className="text-gray-600 mb-6">
          Issue medicines to patients, employees, or handle controlled substances
        </p>

        {/* Notification */}
        {notification && (
          <div
            className={`mb-4 p-4 rounded-md ${
              notification.type === 'success'
                ? 'bg-green-50 border-l-4 border-green-400 text-green-700'
                : 'bg-red-50 border-l-4 border-red-400 text-red-700'
            }`}
          >
            {notification.message}
          </div>
        )}

        <StockIssueForm
          onSubmit={handleSubmit}
          isLoading={loading}
        />
      </div>
    </div>
  );
};

export default StockIssuePage;